<template>
  <div class="book">
    <div class="coverInfo">
      <img class="coverImage" src="//textcafe.co/books/2Mxmux/tc-custom/9781667448268.jpg?1680370567641" alt="This image is the cover for the book The first song"/>
    </div>
    <div class="bookInfo">
      <h1 class="bookTitle heading font1">The first song
      </h1>
      <p class="bookDescription body article font2">
        <p>A miller's son The Dream of Fame The first contract<br/> Ever since he was young, singer and guitarist Florian Müller has wanted to be a successful musician. When the famous producer Dietmar Weiss offers him a record deal, he sees his dream within reach. Without thinking twice, he signs the contract.<br/> But then he has doubts. Was it really wise to give away the rights to his song so lightly? What if the Schlager producer messes up his metal ballad completely? Flo feverishly searches for a way out - and then singer Mia enters his life...<br/> Rumpelstiltskin in a different way: In "The First Song", author Susanne Eisele retells the well-known fairy tale of the Brothers Grimm and deals with the lure of quick fame, the pitfalls of the music industry and the solidarity among friends.<br/> Volume 14 from the ranks of the fairy tale spinning mill<br/></p>
      </p>
    </div>
    <div class="authorInfo">
      <h2 class="authorName heading font1">
        Susanne Eisele, Lia Garcia
      </h2>
      
      <p class="authorDescription body article">Susanne Eisele discovered her love for music and books early on. This love accompanies her to this day. Over time, she began to want to write books herself. With -Neighborhood Help - a vampire and werewolf thriller- she finally put this wish into practice. Susanne Eisele lives with her husband in the northern Black Forest. The follow-up volume -Kinderspiel- was released in September 2015.<br/> In 2017 and 2018 she published the fairy tale adaptations -No snow in the witch's house- and -The first song- as part of the fairy tale spinning workshop. She also published her own anthology - Susanne's short stories from space and time - in 2019. Other short stories by her can be found in anthologies from various publishers.<br/> Facebook page: https://www.facebook.com/SusanneEiseleAutorin/<br/> Homepage: www.autorin-susanne-eisele.de<br/></p>
      
      
    </div>
    <div class="publisherInfo">
     <h2 class="publisherName heading font1">
      Babelcube Inc.
     </h2>
        
        
     
    </div>
  </div>
</template>

<script>
// import Navigation from '@/components/Navigation'
export default {
  name: 'home',
  data() {
    return {}
  },
  components: {
    // 'navigation': Navigation
  }
}
</script>


// WEBPACK FOOTER //
// home.vue?45ff4e5a